import { LabCardData } from "@hub/models/document/document-card-data";
import { HeadMetadata } from "@hub/models/metadata/head-metadata";
import { BannerConfig } from "@hub/models/ui/banner-config";
import { Breadcrumb } from "@hub/models/ui/breadcrumb";
import { PageConfig } from "@hub/models/ui/page-config";
import { Auth0Header } from "@hub/ui/auth0/auth0-header";
import { HeroBanner } from "@hub/ui/banners/hero-banner";
import { Breadcrumbs } from "@hub/ui/breadcrumbs/breadcrumbs";
import { WorkshopCard } from "@hub/ui/cards/workshop-card";
import styles from "@hub/ui/layouts/results-page-layout.module.css";
import { ShellLayout } from "@hub/ui/layouts/shell-layout";
import React from "react";

interface AllWorkshopsPageProps {
  breadcrumbs?: Breadcrumb[];
  headMetadata?: HeadMetadata;
  pageConfig: PageConfig;
  bannerConfig: BannerConfig;
  contentCardData: LabCardData[];
}

export const AllWorkshopsPage: React.FC<AllWorkshopsPageProps> = ({
  breadcrumbs,
  headMetadata,
  pageConfig,
  bannerConfig,
  contentCardData,
}) => {
  return (
    <ShellLayout
      header={<Auth0Header />}
      pageConfig={pageConfig}
      headMetadata={headMetadata}
      breadcrumbs={
        breadcrumbs ? <Breadcrumbs breadcrumbs={breadcrumbs} /> : null
      }
      banner={<HeroBanner {...bannerConfig} />}
      document={
        <>
          <div className={styles.workshops}>
            {contentCardData.length > 0 &&
              contentCardData.map((result) => {
                return (
                  <React.Fragment key={result.path}>
                    <WorkshopCard data={result} testName="workshop" />
                  </React.Fragment>
                );
              })}
          </div>
        </>
      }
    />
  );
};
